import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import VideoService from '@/services/VideoService';
import VideoList from '@/components/video-list/List';
import SearchChips from '@/components/video-list/SearchChips';
export default {
  name: 'SearchModal',
  components: {
    VideoList,
    SearchChips
  },
  props: {
    initialSearchQuery: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      searchTerms: this.splitTerms(this.initialSearchQuery),
      searchResults: [],
      loading: false,
      pagination: {
        numPages: 1,
        page: 1,
        perPage: 20,
        rows: 1
      },
      currentPage: 1,
      perPage: 20,
      totalRows: 0
    };
  },
  methods: {
    splitTerms(text) {
      return String(text || '').split(/[\s,]+/).map(t => t.trim()).filter(t => t.length);
    },
    /**
     * Open the modal with the given free text turned into chips and run the search.
     * Called by the navigation bar; the modal itself never searches on keystrokes.
     */
    open(query) {
      this.searchTerms = this.splitTerms(query);
      this.currentPage = 1;
      this.pagination.page = 1;
      this.$bvModal.show('search-modal');
      this.performSearch();
    },
    onChipsSearch() {
      this.currentPage = 1;
      this.pagination.page = 1;
      this.performSearch();
    },
    performSearch() {
      if (this.$refs.chips) {
        this.$refs.chips.commitPending();
      }

      // Nothing to search for: show the empty state without calling the API.
      if (!this.searchTerms.length) {
        this.searchResults = [];
        this.totalRows = 0;
        this.loading = false;
        return;
      }
      this.loading = true;
      const data = {
        // presearch: public, logged-out search. The API only allows an
        // unauthenticated search when this flag is set, so it must always be
        // sent from this modal, even when no chips are present.
        filters: {
          presearch: 1
        },
        pagination: {
          ...this.pagination,
          page: this.currentPage,
          perPage: this.perPage
        }
      };
      if (this.searchTerms.length) {
        data.filters.text_search = this.searchTerms;
      }
      VideoService.search(data).then(response => {
        this.searchResults = response.data.results || [];
        this.totalRows = response.data.totalResults || 0;
      }).catch(error => {
        this.$aim.error(error.response || error);
        this.searchResults = [];
        this.totalRows = 0;
      }).finally(() => {
        this.loading = false;
      });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.pagination.page = page;
      this.performSearch();
    },
    routeToSubscribe() {
      this.$bvModal.hide('search-modal');
      this.$router.push('/subscribe');
    }
  }
};